import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { defineMessages, injectIntl, intlShape } from 'react-intl'
import ConvPy from '../green-flag/convpy.jsx'

import GreenFlag from '../green-flag/green-flag.jsx'
import StopAll from '../stop-all/stop-all.jsx'
import TurboMode from '../turbo-mode/turbo-mode.jsx'
import { BrowserView, MobileView } from 'react-device-detect'

import styles from './controls.css'
import CustomPopup from '../customPopup/customPopup.jsx'

const messages = defineMessages({
    goTitle: {
        id: 'gui.controls.go',
        defaultMessage: 'Go',
        description: 'Green flag button title',
    },
    stopTitle: {
        id: 'gui.controls.stop',
        defaultMessage: 'Stop',
        description: 'Stop button title',
    },
    ConvPyTitle: {
        id: 'gui.controls.ConvPy',
        defaultMessage: 'Convert to python',
        description: 'blocks to python',
    },
})

const Controls = function (props) {
    const {
        active,
        className,
        intl,
        onGreenFlagClick,
        onStopAllClick,

        onConvPyClick,
        turbo,
        handelConsoleClear,
        ...componentProps
    } = props

    return (
        <div
            className={classNames(styles.controlsContainer, className)}
            {...componentProps}
        >
            {/*  show the popup message */}
            <CustomPopup
                isShow={props.isShow}
                handelClosePopup={props.handelClosePopup}
                popupMessage={props.popupMessage}
                popupTitle={props.popupTitle}
            />

            <GreenFlag
                active={active}
                title={intl.formatMessage(messages.goTitle)}
                onClick={onGreenFlagClick}
            />
            {/* swaipe button for code mode change to python to c*/}
            {props.currentMode.isCodingMode && (
                <div
                    className={`${styles.swipe_container} ${
                        props?.currentMode?.isMicroPythonMode ? styles.true : ''
                    }`}
                    onClick={() => {
                        // Currently, only Python code is available; this has not changed.
                        return
                        props.handelScriptChange()
                    }}
                >
                    <div className={styles.swipe_handle}></div>
                    <div className={styles.left_text}>C code</div>
                    <div className={styles.right_text}>Python code</div>
                </div>
            )}

            {/* {props.currentMode.isCodingMode && (
                <button onClick={handelConsoleClear}>clear</button>
            )} */}
            <BrowserView>
                {/* <ConvPy
                    active={active}
                    title={intl.formatMessage(messages.ConvPyTitle)}
                    onClick={onConvPyClick}
                ></ConvPy> */}
            </BrowserView>

            {turbo ? <TurboMode /> : null}
        </div>
    )
}

Controls.propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
    intl: intlShape.isRequired,
    onGreenFlagClick: PropTypes.func.isRequired,
    onStopAllClick: PropTypes.func,
    onConvPyClick: PropTypes.func.isRequired,
    turbo: PropTypes.bool,
    handelConsoleClear: PropTypes.func,
    handelScriptChange: PropTypes.func,
    isShow: PropTypes.bool,
    handelClosePopup: PropTypes.func,
    popupMessage: PropTypes.string,
    popupTitle: PropTypes.string,
}

Controls.defaultProps = {
    active: false,
    turbo: false,
    isShow: false,
    handelConsoleClear: () => {},
    handelScriptChange: () => {},
    handelClosePopup: () => {},
    popupMessage: '',
    popupTitle: '',
}

export default injectIntl(Controls)
